import React from 'react';

interface AuthButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

const AuthButton: React.FC<AuthButtonProps> = ({ children, className = '', ...props }) => (
  <button 
    className={`w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-4 rounded-lg transition-colors duration-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default AuthButton;
